import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Borrow from '../views/Borrow'
import MakeOffer from '../views/MakeOffer'
import Login from '../views/Login'
import LoanRequest from '../views/LoanRequest'
import PageNotFound from '../views/PageNotFound'
import AddTel from '../views/AddTel'
import GetVerified from '../views/getVerified'
import UserMenu from '../views/UserMenu'
import GetTrustScore from '../views/GetTrustScore'
import About from '../views/About'
import ToS from '../views/ToS'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
      path: '/index.html',
      name: 'home',
      component: Home
  },
  {
      path: '/login',
      name: 'login',
      component: Login
  },
    {
        path: '/user',
        name: 'userMenu',
        component: UserMenu
    },
    {
        path: '/addtel',
        name: 'addTel',
        component: AddTel
    },
    {
        path: '/getVerified',
        name: 'getVerified',
        component: GetVerified
    },
    {
        path: '/getTrustScore',
        name: 'getTrustScore',
        component: GetTrustScore
    },
  {
      path: '/borrow',
      name: 'borrow',
      component: Borrow
  },
    {   path: '/videos/:id',
        component: LoanRequest,
        props: true
    },
    {   path: '/requests/:id',
        component: LoanRequest,
        props: true
    },
  {
    path: '/makeOffer',
    name: 'makeOffer',
    component: MakeOffer
  },
    {
        path: '/about',
        name: 'about',
        component: About
    },
    {
        path: '/terms',
        name: 'tos',
        component: ToS
    },
    {   path: "*",
        name: 'PageNotFound',
        component: PageNotFound
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
